<template>
  <v-menu v-if="menuItems" left offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" icon v-on="on">
        <v-icon>mdi-dots-horizontal</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-tooltip
        v-for="(menuItem, index) in menuItems"
        :key="`menuItem_${index}`"
        left
      >
        <template v-slot:activator="{ on }">
          <v-list-item
            :disabled="menuItem.disabled"
            v-on="on"
            @click="menuItem.action"
          >
            <v-list-item-icon class="mr-2">
              <v-icon small>{{ menuItem.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ menuItem.title }}</v-list-item-title>
          </v-list-item>
        </template>
        <p style="color: white">
          {{ menuItem.message }}
        </p>
      </v-tooltip>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    menuItems: {
      type: Array,
      required: true
    }
  }
}
</script>
